module.exports = __webpack_public_path__ + "static/media/Tell_Your_Guests_QR_Code.5a6dca93.png";